import { useEffect, useState } from 'react';

import { Box, Grid } from '@mui/material';

import { useFormErrorDispatch } from '@/providers/FormErrorContext';
import {
  FORM_CLEAR_ERROR,
  FORM_SET_ERROR,
} from '@/providers/actionTypes';
import { useUser } from '@/providers/UserContext';
import AccountFirstNameField from './AccountFirstNameField';
import AccountLastNameField from './AccountLastNameField';
import AccountEmailField from './AccountEmailField';
// import AccountPhoneField from './AccountPhoneField';
// import AccountCountryField from './AccountCountryField';
import type { SetValuesCallback } from '@/types';

interface AccountContactFormProps {
  setValues: SetValuesCallback;
}

function AccountContactForm({ setValues }: AccountContactFormProps) {
  const user = useUser();
  const formErrorDispatch = useFormErrorDispatch();
  const [revision, setRevision] = useState<number>(0);
  const [first_name, setFirstName] = useState<string>(user?.first_name || '');
  const [first_name_error, setFirstNameError] = useState<string | boolean>(
    false,
  );
  const [last_name, setLastName] = useState<string>(user?.last_name || '');
  const [last_name_error, setLastNameError] = useState<string | boolean>(
    false,
  );
  // const [phone, setPhone] = useState(user?.phone || '');
  // const [phone_error, setPhoneError] = useState(false);
  const [email, setEmail] = useState<string>(user?.email || '');
  const [email_error, setEmailError] = useState<string | boolean>(false);
  // const [country, setCountry] = useState(user?.country || '');
  // const [country_error, setCountryError] = useState(false);

  useEffect(() => {
    setRevision((prevState) => prevState + 1);
  }, [user]);
  useEffect(() => {
    if (
      first_name_error ||
      first_name === '' ||
      last_name_error ||
      last_name === '' ||
      email_error ||
      email === ''
      // ||     phone_error ||
      // phone === '' ||
      // country_error ||
      // country === ''
    ) {
      formErrorDispatch({ type: FORM_SET_ERROR, payload: true });
    } else {
      formErrorDispatch({ type: FORM_CLEAR_ERROR });
    }
  }, [
    formErrorDispatch,
    first_name,
    email,
    last_name,
    // phone,
    // country,
    first_name_error,
    last_name_error,
    email_error,
    // phone_error,
    // country_error,
  ]);

  useEffect(() => {
    setValues({
      first_name,
      email,
      last_name,
      // phone,
      // country,
    });
  }, [
    setValues,
    first_name,
    email,
    last_name,
    // phone,
    // country
  ]);

  return (
    <Box width='100%' padding='15px'>
      {/* <Paper sx={{ display: 'flex', width: '100%' }}> */}
      <Grid container spacing={2}>
        <Grid size={12}>
          <Box
            padding='15px'
            sx={{
              maxWidth: 600,
            }}
          >
            <Grid container spacing={2}>
              <Grid size={12}>
                <AccountFirstNameField
                  key={`first_name_${revision}`}
                  value={first_name}
                  error={first_name_error}
                  setValue={setFirstName}
                  setError={setFirstNameError}
                />
              </Grid>
              <Grid size={12}>
                <AccountLastNameField
                  key={`last_name_${revision}`}
                  value={last_name}
                  error={last_name_error}
                  setValue={setLastName}
                  setError={setLastNameError}
                />
              </Grid>
              <Grid size={12}>
                <AccountEmailField
                  key={`email_${revision}`}
                  value={email}
                  error={email_error}
                  setValue={setEmail}
                  setError={setEmailError}
                />
              </Grid>
              {/* <Grid size={12}>
                <AccountPhoneField
                  key={`phone_${revision}`}
                  value={phone}
                  error={phone_error}
                  setValue={setPhone}
                  setError={setPhoneError}
                />
              </Grid>
              <Grid size={12}>
                <AccountCountryField
                  key={`country_${revision}`}
                  value={country}
                  error={country_error}
                  setValue={setCountry}
                  setError={setCountryError}
                />
              </Grid> */}
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {/* </Paper> */}
    </Box>
  );
}

export default AccountContactForm;

